module.exports = __webpack_public_path__ + "img/TZS09702.99f5f878.jpeg";